import { useState } from 'react'
import { Alert, App, Button, Form, Input, Modal, Space } from 'antd'
import { changeMemberPassword } from '@/entities/member'

type ChangePasswordModalProps = {
  open: boolean
  onClose: () => void
  force?: boolean
  onLogout?: () => void | Promise<void>
  onChanged?: () => void | Promise<void>
}

export function ChangePasswordModal({ open, onClose, force = false, onLogout, onChanged }: ChangePasswordModalProps) {
  const { message } = App.useApp()
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [saving, setSaving] = useState(false)
  const [loggingOut, setLoggingOut] = useState(false)

  const reset = () => {
    setOldPassword('')
    setNewPassword('')
  }

  const savePassword = async () => {
    setSaving(true)
    try {
      await changeMemberPassword(oldPassword, newPassword)
      reset()
      await onChanged?.()
      onClose()
      void message.success(force ? '密码已修改，请继续使用' : '密码已修改')
    } catch (error) {
      void message.error(error instanceof Error ? error.message : '密码修改失败')
    } finally {
      setSaving(false)
    }
  }

  const logout = async () => {
    if (!onLogout) return
    setLoggingOut(true)
    try {
      await onLogout()
    } finally {
      setLoggingOut(false)
    }
  }

  return <Modal
    open={open}
    title={force ? '首次登录需修改密码' : '修改密码'}
    width={520}
    footer={null}
    afterClose={reset}
    closable={!force}
    maskClosable={!force}
    keyboard={!force}
    {...(force ? {} : { onCancel: onClose })}
  >
    <Form layout="vertical">
      {force && <Alert
        type="info"
        showIcon
        message="为了保护你的账号安全，首次登录需要先设置一个新的密码。"
        description="完成修改后即可进入工作台；如果暂时不想继续，可以退出登录后稍后再处理。"
        style={{ marginBottom: 16 }}
      />}
      <Form.Item label="当前密码" required><Input.Password value={oldPassword} autoComplete="current-password" onChange={(event) => setOldPassword(event.target.value)} /></Form.Item>
      <Form.Item label="新密码" required><Input.Password value={newPassword} autoComplete="new-password" onChange={(event) => setNewPassword(event.target.value)} /></Form.Item>
      {force
        ? <Space.Compact block>
          <Button loading={loggingOut} disabled={saving} onClick={() => void logout()}>退出登录</Button>
          <Button block type="primary" loading={saving} disabled={!oldPassword || !newPassword || loggingOut} onClick={() => void savePassword()}>确认修改</Button>
        </Space.Compact>
        : <Button block type="primary" loading={saving} disabled={!oldPassword || !newPassword} onClick={() => void savePassword()}>确认修改</Button>}
    </Form>
  </Modal>
}
